import { SignalDispatcher } from 'ste-signals';
import { SimpleEventDispatcher } from 'ste-simple-events';

export const compositionGroupEvents = {
  onRename: new SignalDispatcher(),
  onCopy: new SignalDispatcher(),
  onCreate: new SignalDispatcher(),
  onArchived: new SignalDispatcher(),
  onRestored: new SignalDispatcher(),
  onLayoutChanged: new SignalDispatcher(),
  onArtworkChanged: new SimpleEventDispatcher<number>(),
  onMarkReady: new SignalDispatcher(),
  onMarkNotReady: new SignalDispatcher(),
  onColorsChanged: new SignalDispatcher(),
};
